import React from "react";
import EditInputElement from "../../Common/EditInputElement";
import { useSelector } from "react-redux";

export const WidgetCardTitle = ({ widget, displayName, setDisplayName }) => {
    const titleFontSize = useSelector((state) => {
        const fontSizes = state.fontManager.fontSizes;
        const normalizedKey = Object.keys(fontSizes).find(
            (key) => key.trim() === "titleFontSize"
        );
        return fontSizes[normalizedKey] || 16;
    });

    const widgetResize =
        widget.layout.w < 5
            ? "50%"
            : widget.layout.w > 15
              ? "90%"
              : widget.layout.w > 8
                ? "85%"
                : "75%";

    const handleKeyDown = (event, value) => {
        if (event.key === "Enter") {
            setDisplayName(value);
        }
    };

    if (widget.gridData.without_header) {
        return (
            <div style={{ width: widgetResize }}>
                <div style={{ height: "30px", paddingRight: "20px" }}>
                    <EditInputElement
                        maxWidth={widget.layout.w * 100 + `px`}
                        style={{
                            fontWeight: "bold",
                            fontSize: `${titleFontSize}px`,
                        }}
                        initialValue={displayName}
                        onSave={(value) => {
                            setDisplayName(value);
                        }}
                        onMouseDown={(e) => e.stopPropagation()}
                        onKeyDown={(e) => handleKeyDown(e, displayName)}
                        placeholder="Enter Widget Name"
                        isAuthor={true}
                    />
                </div>
            </div>
        );
    }

    return (
        <>
            <div style={{ paddingRight: "20px", width: widgetResize }}>
                <EditInputElement
                    maxWidth={widget.layout.w * 100 + `px`}
                    style={{
                        fontWeight: "bold",
                        fontSize: `${titleFontSize}px`,
                    }}
                    initialValue={displayName}
                    onSave={(value) => {
                        setDisplayName(value);
                    }}
                    onMouseDown={(e) => e.stopPropagation()}
                    onKeyDown={(e) => handleKeyDown(e, displayName)}
                    placeholder="Enter Widget Name"
                    isAuthor={true}
                />
            </div>
        </>
    );
};
